<div class="min-h-screen overflow-x-hidden pl-[260px]">
  <aside class="fixed left-0 top-0 z-[1000] flex h-screen w-[260px] flex-col border-r border-slate-200 bg-white shadow-sm">
    <div class="flex items-center gap-3 border-b border-slate-100 px-5 py-6">
      <img src="assets/images/logo.png" alt="Brickhub" class="h-10 w-10 shrink-0" />
      <div>
        <div class="font-outfit text-lg font-bold tracking-tight text-slate-900">
          Brick<span class="text-indigo-500">hub</span>
        </div>
        <div class="text-[9.5px] font-bold uppercase tracking-wide text-slate-500">Subscription Config</div>
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto px-3 py-4">
      <div class="px-3 pb-1 pt-3 text-[10.5px] font-extrabold uppercase tracking-wider text-slate-400">Main Menu</div>
      <a routerLink="/dashboard" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-chart-pie w-[18px] text-center"></i> Platform Dashboard
      </a>

      <div class="px-3 pb-1 pt-4 text-[10.5px] font-extrabold uppercase tracking-wider text-slate-400">Tenant Management</div>
      <a routerLink="/tenants/builders" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-building-flag w-[18px] text-center"></i> Builders Management
      </a>
      <a routerLink="/tenants/channel-partners" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-handshake w-[18px] text-center"></i> Channel Partners
      </a>

      <div class="px-3 pb-1 pt-4 text-[10.5px] font-extrabold uppercase tracking-wider text-slate-400">Subscription</div>
      <a routerLink="/subscription/catalog" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-sitemap w-[18px] text-center"></i> Module Grouping
      </a>
      <a routerLink="/subscription/features" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-toggle-on w-[18px] text-center"></i> Features
      </a>
      <a routerLink="/subscription/addons" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-puzzle-piece w-[18px] text-center"></i> Add-Ons
      </a>
      <a routerLink="/subscription/plans" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-crown w-[18px] text-center"></i> Plan Builder
      </a>

      <div class="px-3 pb-1 pt-4 text-[10.5px] font-extrabold uppercase tracking-wider text-slate-400">Transactions</div>
      <a routerLink="/financial/invoices" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-file-invoice-dollar w-[18px] text-center"></i> Invoices
      </a>
      <a routerLink="/financial/payments" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-money-bill-transfer w-[18px] text-center"></i> Payments
      </a>

      <div class="px-3 pb-1 pt-4 text-[10.5px] font-extrabold uppercase tracking-wider text-slate-400">Governance</div>
      <a routerLink="/governance" routerLinkActive="sa-nav-active" class="sa-nav-item">
        <i class="fa-solid fa-shield-halved w-[18px] text-center"></i> Governance
      </a>
    </nav>

    <div class="flex items-center gap-3 border-t border-slate-100 bg-indigo-50/30 px-5 py-4">
      <div class="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 text-xs font-bold text-white">SA</div>
      <div>
        <div class="text-xs font-bold">Super Admin</div>
        <div class="text-[11px] text-slate-500">platform-owner</div>
      </div>
    </div>
  </aside>

  <div class="flex min-h-screen min-w-0 flex-col">
    <header class="sticky top-0 z-[999] flex min-h-[70px] items-center justify-between border-b border-slate-200 bg-white/90 px-8 py-3 backdrop-blur-md">
      <div>
        <h2 class="font-outfit text-[17px] font-extrabold text-slate-900">
          <i class="fa-solid mr-2 text-indigo-500" [class]="pageIcon"></i>
          {{ pageTitle }}
        </h2>
        @if (pageSubtitle) {
          <p class="mt-0.5 text-xs text-slate-500">{{ pageSubtitle }}</p>
        }
      </div>
      <div class="flex items-center gap-3">
        @if (pageBadge) {
          <span class="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 px-2.5 py-1 text-[11px] font-bold text-indigo-600">
            <i class="fa-solid" [class]="pageIcon"></i> {{ pageBadge }}
          </span>
        }
        <div class="inline-flex items-center gap-1.5 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-[11.5px] font-bold text-emerald-700">
          <span class="h-1.5 w-1.5 rounded-full bg-emerald-500 shadow shadow-emerald-500"></span>
          All Systems Normal
        </div>
        <button type="button" class="relative flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-slate-500 hover:bg-slate-100" title="Approvals">
          <i class="fa-regular fa-bell"></i>
          <span class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-white bg-red-500 text-[9px] font-bold text-white">3</span>
        </button>
        <div class="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 text-xs font-bold text-white">SA</div>
        <button type="button" class="sa-btn-secondary" (click)="logout()">Logout</button>
      </div>
    </header>

    <main class="min-w-0 flex-1 overflow-x-clip px-8 py-4">
      <router-outlet />
    </main>
  </div>
</div>
